import { MouseEvent, ReactNode, forwardRef } from 'react';
import { TypographyVariant, Color, Weight, TextTransform } from 'src/latest/src/types';
import './typography.scss';

interface Props {
    className?: string;
    component?: string;
    children?: ReactNode;
    /** font-size. */
    variant?: TypographyVariant;
    /** color */
    color?: Color;
    /** font-weight. */
    weight?: Weight;
    dangerouslySetInnerHTML?: {
        __html: string;
    };
    onClick?: (event: MouseEvent<HTMLElement>) => void;
    [key: string]: any;
    textTransform?: TextTransform;
}

export const Typography = forwardRef<HTMLElement, Props>(({
    component = 'p',
    className = '',
    variant = 'size-16',
    color = 'color-2',
    weight = 'regular',
    children,
    onClick,
    textTransform,
    ...props
}, ref) => {
    // Use the 'component' prop directly.
    // Previously, logic here was forcing it to be 'p' or 'span' only which was causing the multiple console errors and warnings.
    const Component = component as any;

    const classNames = [
        'typography',
        variant,
        color,
        `weight-${weight}`,
        className,
        `transform-${textTransform}`
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <Component
            ref={ref}
            {...props}
            onClick={onClick}
            className={classNames}
        >
            {children}
        </Component>
    );
});
